<template>
  <span>
    <template v-if="deleted">
      <span :style="textStyle">{{ value }}</span>
      <el-tooltip :content="content" placement="right">
        <v-icon :color="iconColor" small class="ml-1 mt-n1">{{ icon }}</v-icon>
      </el-tooltip>
    </template>
    <template v-else>
      {{ value }}
    </template>
  </span>
</template>

<script>
export default {
  name: "DeletableField",
  props: {
    value: {
      type: String,
      required: false
    },
    deleted: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: '削除済'
    },
    icon: {
      type: String,
      default: 'el-icon-warning'
    },
    iconColor: {
      type: String,
      default: 'red'
    },
    textStyle: {
      type: [String, Object],
      default: () => ({textDecoration: 'line-through'})
    }
  },
}
</script>
